<template>
    <div class="flex w-full items-center gap-3 p-3">

        <div class="flex shrink-0 items-center">

            <div class="th-tooltip th-tooltip-bottom-start th-tooltip-dark h-6" :data-tip="$t('list')">
                <button class="th-btn-only-icon th-btn th-btn-plain th-btn-sm" @click="handleResult">
                    <PtIcon icon="SolidComment" class="th-btn-icon text-2xl" />
                </button>
            </div>

            <div class="th-tooltip th-tooltip-bottom-start th-tooltip-dark h-6"
                 :data-tip="prevDisabled ? $t('first_sentence') : $t('prev')">
                <button class="th-btn-only-icon th-btn th-btn-plain th-btn-sm" :disabled="prevDisabled" @click="handlePrev">
                    <PtIcon icon="SolidArrowLeft" class="th-btn-icon text-2xl" />
                </button>
            </div>

            <span class="mx-1 text-base">
                <span class="text-black">{{ currentIndex }}</span><span class="text-grey-90">/{{ totalList }}</span>
            </span>

            <div class="th-tooltip th-tooltip-bottom-start th-tooltip-dark h-6"
                 :data-tip="nextDisabled ? $t('last_sentence') : $t('next')">
                <button class="th-btn-only-icon th-btn th-btn-plain th-btn-sm" :disabled="nextDisabled" @click="handleNext">
                    <PtIcon icon="SolidArrowRight" class="th-btn-icon text-2xl" />
                </button>
            </div>
        </div>

        <SimilarTag v-if="detailBasicInfo?.similarity"
                    :label="$t('similarity')"
                    :similarity="detailBasicInfo.similarity"
                    class="shrink-0"/>

        <span class="grow">
            <a class="text-base text-black hover:text-eureka-600 hover:underline" v-html="detailBasicInfo?.title"
               :href="patentViewLink" target="_blank"></a>
            <LegalStatus :legal_status="detailBasicInfo?.legal_status"  class="ml-2"/>
        </span>

        <button class="th-btn th-btn-text th-btn-sm shrink-0" @click="addIntoReport">
            <PtIcon :icon="detailBasicInfo?.addedReport ? 'SolidTick': 'SolidAddMedium'" class="th-btn-icon text-2xl" />
            <span>{{ detailBasicInfo?.addedReport ? $t('addedReport') : $t('addIntoReport') }}</span>
        </button>
    </div>
</template>
<script setup lang="ts">
import { PtIcon } from 'patsnap-biz'
import type { IBaseSolution } from '@/types';
import { LegalStatus } from '@eureka/shared/legal-status'
import SimilarTag from '@/components/SimilarTag.vue'
import { computed } from 'vue';
import '@patsnap-ui/icon/assets/solid/AddMedium.svg'
import '@patsnap-ui/icon/assets/solid/tick.svg';
import '@patsnap-ui/icon/assets/solid/ArrowLeft.svg'
import '@patsnap-ui/icon/assets/solid/ArrowRight.svg'
import '@patsnap-ui/icon/assets/solid/comment.svg'

const props = defineProps<{
    prevDisabled?: boolean,
    nextDisabled?: boolean,
    detailBasicInfo?: IBaseSolution,
    totalList?: number,
    currentIndex?: number
}>()

const patentViewLink = computed(() => {
    return `${import.meta.env.VITE_EUREKA_URI}/view/#/fullText'figures/?patentId=${props.detailBasicInfo?.patent_id}`
})

const emits = defineEmits<{
    (e: 'click:handelNext'): void,
    (e: 'click:handelPrev'): void
    (e: 'click:handelToResult'): void
    (e: 'click:handelAddToReport'): void
}>()
function handleNext() {
    emits('click:handelNext')
}

function handlePrev() {
    emits('click:handelPrev')
}

function handleResult() {
    emits('click:handelToResult')
}
function addIntoReport() {
    emits('click:handelAddToReport')
}
</script>
